import React from 'react';
import { Circle } from 'lucide-react';
import { useRecording } from '@contexts/RecordingContext';

export const RecordingControl = () => {
  const { isRecording, toggleRecording } = useRecording();

  const getButtonStyles = (active) => {
    if (active) return 'bg-red-500 text-white';
    return 'bg-gray-700 text-gray-400 hover:bg-gray-600 hover:text-white';
  };

  return (
    <div className="flex flex-col space-y-1">
      <button
        onClick={toggleRecording}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(isRecording)}`}
        title={isRecording ? 'Stop Recording' : 'Start Recording'}
      >
        <Circle className={`w-4 h-4 ${isRecording ? 'animate-pulse' : ''}`} />
        <span className="text-sm">{isRecording ? 'Stop' : 'Start'}</span>
      </button>
    </div>
  );
};